import { Bracket, BracketSeries, GameId } from "@portal-frontend-ssr/blast-api";
import { ErrorBoundary } from "@portal-frontend-ssr/ui";
import { useMemo } from "react";
import { TeamSlot } from "~/routes/_cs.cs.bounty-simulator._index/components/TeamDropdown";
import { PlayoffBracket } from "~/shared/components/Brackets/components/PlayoffBracket";
import { RoundRobinBracket } from "~/shared/components/Brackets/components/RoundRobinBracket";
import { SwissBracket } from "~/shared/components/Brackets/components/SwissBracket";
import { getSortedBrackets } from "./helpers/getSortedBrackets/getSortedBrackets";
export const Brackets = ({
  brackets,
  gameId,
  pickedResults,
  onTeamClick,
  showHeader,
}: {
  brackets: Bracket[] | null;
  gameId: GameId;
  pickedResults?: Record<string, TeamSlot>;
  onTeamClick?: (match: BracketSeries, team: TeamSlot | null) => void;
  showHeader?: boolean;
}) => {
  const sortedBrackets = useMemo(() => {
    if (!brackets) return [];
    return getSortedBrackets(brackets);
  }, [brackets]);

  return (
    <>
      {sortedBrackets.map(({ bracket, isExpanded }, index) => (
        <ErrorBoundary key={index}>
          <BracketItem
            bracket={bracket}
            isExpanded={isExpanded}
            gameId={gameId}
            pickedResults={pickedResults}
            onTeamClick={onTeamClick}
            showHeader={showHeader}
          />
        </ErrorBoundary>
      ))}
    </>
  );
};

const BracketItem = ({
  bracket,
  isExpanded,
  gameId,
  pickedResults,
  onTeamClick,
  showHeader,
}: {
  bracket: Bracket;
  isExpanded: boolean;
  gameId: GameId;
  pickedResults?: Record<string, TeamSlot>;
  onTeamClick?: (match: BracketSeries, team: TeamSlot | null) => void;
  showHeader?: boolean;
}) => {
  return bracket.format === "round-robin" ? (
    <RoundRobinBracket bracket={bracket} shouldBracketExpand={isExpanded} gameId={gameId} />
  ) : bracket.format.includes("swiss") ? (
    <SwissBracket bracket={bracket} shouldBracketBeExpanded={isExpanded} />
  ) : (
    <PlayoffBracket
      bracket={bracket}
      tournamentId={bracket.tournamentUuid}
      shouldBracketExpand={isExpanded}
      gameId={gameId}
      pickedResults={pickedResults}
      onTeamClick={onTeamClick}
      showHeader={showHeader}
    />
  );
};
